// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tips-info {\n  line-height: 18px;\n  color: #c0c4cc;\n  font-size: 12px;\n}\n.parser-form-actions {\n  clear: both;\n}\n", ""]);
// Exports
module.exports = exports;
